import { createFileRoute, redirect } from "@tanstack/react-router";
import { DocumentUpload } from "./DocumentUpload";

/**
 * Route configuration for the document upload page.
 * Requires authentication - redirects to sign-in if not authenticated.
 */
export const Route = createFileRoute("/document-upload/")({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: "/signin",
        search: {
          redirect: "/document-upload",
        },
      });
    }
  },
  component: DocumentUpload,
});
